import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, vModelText as _vModelText, withKeys as _withKeys, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode } from "vue"

const _hoisted_1 = { class: "dynamic-appointment-flow" }
const _hoisted_2 = { key: 0 }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { key: 2 }
const _hoisted_6 = { class: "form-group" }
const _hoisted_7 = { for: "phone-number" }
const _hoisted_8 = ["placeholder"]
const _hoisted_9 = {
  key: 0,
  class: "error-text"
}
const _hoisted_10 = {
  key: 1,
  class: "hint-text"
}
const _hoisted_11 = {
  key: 3,
  class: "suggestions-panel"
}
const _hoisted_12 = {
  key: 0,
  class: "search-results"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 1,
  class: "no-results"
}
const _hoisted_16 = ["disabled"]
const _hoisted_17 = { key: 1 }
const _hoisted_18 = { class: "search-results" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { key: 0 }
const _hoisted_21 = { class: "new-customer-prompt" }
const _hoisted_22 = { key: 2 }
const _hoisted_23 = { key: 3 }
const _hoisted_24 = { class: "customer-label" }
const _hoisted_25 = {
  key: 4,
  class: "submitting-overlay"
}
const _hoisted_26 = {
  key: 5,
  class: "error-text flow-error"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_CustomerForm = _resolveComponent("CustomerForm")!
  const _component_AppointmentForm = _resolveComponent("AppointmentForm")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_ctx.step === 1)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.isAcademyEnquiry ? 'Academy Enquiry' : 'Book an Appointment'), 1),
          (_ctx.isStaff)
            ? (_openBlock(), _createElementBlock("p", _hoisted_3, "Search for a customer by phone number, name, or email."))
            : (_ctx.isAcademyEnquiry)
              ? (_openBlock(), _createElementBlock("p", _hoisted_4, "Enter your phone number to enquire about academy courses."))
              : (_openBlock(), _createElementBlock("p", _hoisted_5, "Enter your phone number to get started.")),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("label", _hoisted_7, _toDisplayString(_ctx.isStaff ? 'Customer Search' : 'Phone Number'), 1),
            _withDirectives(_createElementVNode("input", {
              type: "tel",
              id: "phone-number",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.phoneNumber) = $event)),
              placeholder: _ctx.isStaff ? 'Type phone number or name...' : 'e.g. 9876543210',
              autocomplete: "off",
              onKeyup: _cache[1] || (_cache[1] = _withKeys(
//@ts-ignore
(...args) => (_ctx.searchCustomer && _ctx.searchCustomer(...args)), ["enter"])),
              onInput: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onPhoneInput && _ctx.onPhoneInput(...args)))
            }, null, 40, _hoisted_8), [
              [_vModelText, _ctx.phoneNumber]
            ]),
            (_ctx.phoneError)
              ? (_openBlock(), _createElementBlock("small", _hoisted_9, _toDisplayString(_ctx.phoneError), 1))
              : (_ctx.isStaff && _ctx.isSearching)
                ? (_openBlock(), _createElementBlock("small", _hoisted_10, "Searching..."))
                : _createCommentVNode("", true)
          ]),
          (_ctx.isStaff && _ctx.showStaffSuggestions)
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _cache[10] || (_cache[10] = _createElementVNode("p", { class: "suggestions-title" }, "Matching customers", -1)),
                (_ctx.searchResults.length)
                  ? (_openBlock(), _createElementBlock("ul", _hoisted_12, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (customer) => {
                        return (_openBlock(), _createElementBlock("li", {
                          key: customer.id,
                          onClick: ($event: any) => (_ctx.selectCustomer(customer))
                        }, [
                          _createElementVNode("div", null, [
                            _createElementVNode("strong", null, _toDisplayString(customer.firstName) + " " + _toDisplayString(customer.lastName), 1),
                            _createElementVNode("small", null, _toDisplayString(customer.phoneNumber), 1),
                            (customer.email)
                              ? (_openBlock(), _createElementBlock("small", _hoisted_14, _toDisplayString(customer.email), 1))
                              : _createCommentVNode("", true)
                          ]),
                          _cache[9] || (_cache[9] = _createElementVNode("span", { class: "select-hint" }, "Select →", -1))
                        ], 8, _hoisted_13))
                      }), 128))
                    ]))
                  : (!_ctx.isSearching && _ctx.phoneNumber.trim().length >= _ctx.minSuggestionLength)
                    ? (_openBlock(), _createElementBlock("p", _hoisted_15, " No customers found. Click Continue to create a new profile. "))
                    : _createCommentVNode("", true),
                (_ctx.phoneNumber.trim().length >= _ctx.minSuggestionLength)
                  ? (_openBlock(), _createElementBlock("button", {
                      key: 2,
                      type: "button",
                      class: "btn btn-secondary btn-block",
                      onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.proceedToCreateFromSearch && _ctx.proceedToCreateFromSearch(...args)))
                    }, " + Create New Customer "))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.searchCustomer && _ctx.searchCustomer(...args))),
            class: "btn btn-primary",
            disabled: _ctx.isSearching
          }, _toDisplayString(_ctx.isSearching ? 'Searching...' : 'Continue'), 9, _hoisted_16)
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 2)
      ? (_openBlock(), _createElementBlock("div", _hoisted_17, [
          _cache[14] || (_cache[14] = _createElementVNode("h2", null, "Select Your Profile", -1)),
          _createElementVNode("p", null, [
            _createTextVNode("We found " + _toDisplayString(_ctx.searchResults.length) + " profile(s) for ", 1),
            _createElementVNode("strong", null, _toDisplayString(_ctx.phoneNumber), 1),
            _cache[11] || (_cache[11] = _createTextVNode(". Please select yours."))
          ]),
          _createElementVNode("ul", _hoisted_18, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.searchResults, (customer) => {
              return (_openBlock(), _createElementBlock("li", {
                key: customer.id,
                onClick: ($event: any) => (_ctx.selectCustomer(customer))
              }, [
                _createElementVNode("div", null, [
                  _createElementVNode("strong", null, _toDisplayString(customer.firstName) + " " + _toDisplayString(customer.lastName), 1),
                  (customer.email)
                    ? (_openBlock(), _createElementBlock("small", _hoisted_20, _toDisplayString(customer.email), 1))
                    : _createCommentVNode("", true)
                ]),
                _cache[12] || (_cache[12] = _createElementVNode("span", { class: "select-hint" }, "Select →", -1))
              ], 8, _hoisted_19))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, [
            _cache[13] || (_cache[13] = _createElementVNode("p", null, "Not you? Create a new profile with this phone number.", -1)),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.proceedToCreate && _ctx.proceedToCreate(...args))),
              class: "btn btn-secondary"
            }, "Create New Profile"),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.goBackToPhone && _ctx.goBackToPhone(...args))),
              class: "btn btn-link"
            }, "← Change phone number")
          ])
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 3)
      ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
          _createElementVNode("h2", null, _toDisplayString(_ctx.isAcademyEnquiry ? 'Your Details' : 'Create Your Profile'), 1),
          _createElementVNode("p", null, [
            _cache[15] || (_cache[15] = _createTextVNode(" We couldn't find a profile for ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.phoneNumber), 1),
            _createTextVNode(". " + _toDisplayString(_ctx.isAcademyEnquiry ? 'Please enter your details to submit your enquiry.' : 'Please enter your details.'), 1)
          ]),
          _createVNode(_component_CustomerForm, {
            "is-embedded": true,
            "is-public-booking": !_ctx.isStaff,
            customer: { phoneNumber: _ctx.phoneNumber },
            onSaveSuccess: _ctx.handleCustomerSave,
            onClose: _ctx.goBackToPhone
          }, null, 8, ["is-public-booking", "customer", "onSaveSuccess", "onClose"]),
          _createElementVNode("button", {
            onClick: _cache[7] || (_cache[7] = 
//@ts-ignore
(...args) => (_ctx.goBackToPhone && _ctx.goBackToPhone(...args))),
            class: "btn btn-link"
          }, "← Back to phone number")
        ]))
      : _createCommentVNode("", true),
    (_ctx.step === 4 && !_ctx.isAcademyEnquiry)
      ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
          _cache[17] || (_cache[17] = _createElementVNode("h2", null, "Book Appointment", -1)),
          _createElementVNode("p", _hoisted_24, [
            _cache[16] || (_cache[16] = _createTextVNode(" Booking for: ")),
            _createElementVNode("strong", null, _toDisplayString(_ctx.selectedCustomer?.firstName) + " " + _toDisplayString(_ctx.selectedCustomer?.lastName), 1),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.changeCustomer && _ctx.changeCustomer(...args))),
              class: "btn btn-link"
            }, "Change")
          ]),
          _createVNode(_component_AppointmentForm, {
            "is-embedded": true,
            customer: _ctx.selectedCustomer,
            "show-price": _ctx.showPrice,
            "is-staff": _ctx.isStaff,
            onSubmit: _ctx.handleAppointmentSubmit,
            onCancel: _ctx.goBackToPhone
          }, null, 8, ["customer", "show-price", "is-staff", "onSubmit", "onCancel"])
        ]))
      : _createCommentVNode("", true),
    (_ctx.isSubmitting)
      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
          _createElementVNode("p", null, _toDisplayString(_ctx.isAcademyEnquiry ? 'Submitting your enquiry...' : 'Booking your appointment...'), 1)
        ]))
      : _createCommentVNode("", true),
    (_ctx.flowError)
      ? (_openBlock(), _createElementBlock("p", _hoisted_26, _toDisplayString(_ctx.flowError), 1))
      : _createCommentVNode("", true)
  ]))
}